// --------------------------
// Update Cart Count Functionality
// --------------------------

function updateCartCount() {
  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-qty-message').forEach(function(el) {
        el.innerText = cart.item_count;
      });
    })
    .catch(function(error) {
      console.error('Error fetching cart:', error);
    });
}

// --------------------------
// Update Product Card Green Text Functionality
// --------------------------

function updateGreenText(container) {
  const isSpanish = window.location.pathname.startsWith('/es/');
  const input = container.querySelector('.quantity__input');
  const message = container.closest('.card-wrapper')?.querySelector('.cart-qty-message');

  if (input && message) {
    const qty = parseInt(input.value, 10);
    if (qty > 0) {
      const text = isSpanish
        ? `⬤ ${qty} ${qty === 1 ? 'pza' : 'pzas'} en su carrito`
        : `⬤ ${qty} ${qty === 1 ? 'pc' : 'pcs'} in your cart`;
      message.textContent = text;
      message.style.textAlign = 'left';
      message.style.fontSize = '1.2rem';
      message.style.color = 'green';
      message.style.fontWeight = '600';
      message.style.letterSpacing = '-0.2px';
    } else {
      message.textContent = '';
    }
  }
}

// --------------------------
// Run updateGreenText on initial load
// --------------------------

document.addEventListener("DOMContentLoaded", function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const variantMap = {};
      cart.items.forEach(item => {
        variantMap[item.id] = item.quantity;
      });

      document.querySelectorAll('.quick-add-bulk').forEach(container => {
        const variantId = parseInt(container.dataset.variantId, 10);
        const input = container.querySelector('.quantity__input');
        if (input) {
          input.value = variantMap[variantId] || 0;
          input.addEventListener('change', function () {
            updateGreenText(container);
          });
        }
        updateGreenText(container);
      });
    });
});
// --------------------------
// Listen for Shopify Section Reloads
// --------------------------

document.addEventListener('shopify:section:load', function () {
  document.querySelectorAll('.quick-add-bulk').forEach(function (container) {
    updateGreenText(container);
    const input = container.querySelector('.quantity__input');
    if (input && !input.dataset.greenTextListener) {
      input.addEventListener('change', function () {
        updateGreenText(container);
      });
      input.dataset.greenTextListener = true;
    }
  });
});

// --------------------------
// Manual trigger (if needed externally)
// --------------------------

window.runGreenCartUpdate = function () {
  document.querySelectorAll('.quick-add-bulk').forEach(container => {
    updateGreenText(container);
    const input = container.querySelector('.quantity__input');
    if (input && !input.dataset.greenTextListener) {
      input.addEventListener('change', function () {
        updateGreenText(container);
      });
      input.dataset.greenTextListener = true;
    }
  });
};


// Function to update product card with quantity and green text
function updateProductCard(container, quantity, isSpanish) {
  const input = container.querySelector('.quantity__input');
  const message = container.closest('.card-wrapper')?.querySelector('.cart-qty-message');

  if (input) input.value = quantity;

  if (message) {
    const text = isSpanish
      ? `⬤ ${quantity} ${quantity === 1 ? 'pza' : 'pzas'} en su carrito`
      : `⬤ ${quantity} ${quantity === 1 ? 'pc' : 'pcs'} in your cart`;
    message.textContent = quantity > 0 ? text : '';
    message.style.textAlign = 'left';
    message.style.fontSize = '1.2rem';
    message.style.color = 'green';
    message.style.fontWeight = '600';
    message.style.letterSpacing = '-0.2px';
  }
}

// Function to synchronize cart quantities with visible products
function syncCartToVisibleProducts() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const isSpanish = window.location.pathname.startsWith('/es/');
      const variantMap = {};
      cart.items.forEach(item => variantMap[item.id] = item.quantity);

      document.querySelectorAll('.quick-add-bulk').forEach(container => {
        const variantId = parseInt(container.dataset.variantId, 10);
        const quantity = variantMap[variantId] || 0;
        updateProductCard(container, quantity, isSpanish);

        const input = container.querySelector('.quantity__input');
        if (input && !input.dataset.listenerAttached) {
          input.addEventListener('change', () => {
            updateProductCard(container, parseInt(input.value, 10), isSpanish);
          });
          input.dataset.listenerAttached = true;
        }
      });
    });
}

// Initial load
document.addEventListener('DOMContentLoaded', syncCartToVisibleProducts);

// Section reload
document.addEventListener('shopify:section:load', syncCartToVisibleProducts);

// Facets (filters) update — with observer for when product cards are added
// --------------------------
// Facets (filters) update
// --------------------------

document.addEventListener('facets:updated', () => {
  setTimeout(() => {
    syncCartToVisibleProducts();
  }, 500); // Adjust the delay if needed
});